import React from 'react'

const SendIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='40'
    height='34'
    viewBox='0 0 40 34'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.25 33.6663V21.1663L16.9167 16.9997L0.25 12.833V0.333008L39.8333 16.9997L0.25 33.6663Z'
      fill='currentcolor'
    />
  </svg>
)

export default SendIcon
